<div class="d-flex justify-content-between align-items-center m-1 p-1" style="min-height: 40px; line-height: 40px;">
    <div>
        <button mat-icon-button (click)="navBack()">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
    </div>
    <div style="align-self: center;">
        <div style="align-self: center;">
            <h5>{{'title_invite_person' | translate}}</h5>
        </div>
    </div>
    <div></div>
</div>
<div [hidden]="!show" class="m-3">
    <mat-card>
        <div *ngIf="dataSource">
            <form [formGroup]="personFilterForm" class="search__form">
                <mat-form-field class="search__form_field" appearance="outline">
                    <mat-label>{{'SHARED.SEARCH_BOX' | translate}}</mat-label>
                    <input matInput type="text" formControlName="searchString" placeholder="{{'invite_search_txt_hint' | translate}}">
                    <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="personFilterForm.controls.searchString.reset()">
                      <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </form>
            <div *ngIf="dataSource.data?.length > 0; else noItems"  class="table-container">
                <table mat-table matSort [dataSource]="dataSource">
                    <ng-container matColumnDef="anzeigeName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TABLE.eventInvitation.personAnzeigeName' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{ element.anzeigeName }} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="telefon">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TABLE.eventInvitation.telefon' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> 
                            <div *ngIf="element.telefon">{{ element.telefon }} </div>
                            <div *ngIf="element.telefon == undefined">
                                {{'TABLE.eventInvitation.no_phone' | translate}}
                            </div>
                        </td>
                    </ng-container>
        
                    <ng-container matColumnDef="emailAddresse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TABLE.eventInvitation.personEmailAddresse' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> 
                            <div *ngIf="element.emailAddresse">{{ element.emailAddresse }}</div>
                            <div *ngIf="element.emailAddresse == undefined">
                                {{'TABLE.eventInvitation.no_email' | translate}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="copy"> 
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'more_options_inv_link' | translate }}  </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="{{ 'hint_copy_invitation_link' | translate}}" (click)="getInvitationLink(element); $event.stopPropagation();">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr (click)="editBasedOnPerson(row)" style="cursor:pointer" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
        <mat-paginator [pageSizeOptions]="paginatorPageSizeOptions">
        </mat-paginator>
    </mat-card>
</div>
